const prefix = 'ak-editor-sync-block';
export const SyncBlockSharedCssClassName: {
    prefix: string;
    renderer: string;
    error: string;
    loading: string;
} = {
	prefix,
	renderer: `${prefix}__renderer`,
	error: `${prefix}__error_state`,
	loading: `${prefix}__loading_state`,
};

export const SyncBlockRendererDataAttributeName = 'data-sync-block-renderer';

const bodiedPrefix = 'ak-editor-bodied-sync-block';
export const BodiedSyncBlockSharedCssClassName: {
    prefix: string;
    renderer: string;
    content: string;
    selectionInside: string;
} = {
	prefix: bodiedPrefix,
	renderer: `${bodiedPrefix}__renderer`,
	content: `${bodiedPrefix}__content`,
	selectionInside: `${bodiedPrefix}__selection_inside`,
};

const labelClassName = 'ak-editor-sync-block__label';
export const SyncBlockLabelSharedCssClassName: {
    labelClassName: string;
} = {
	labelClassName,
};

export const disabledClassName = 'disabled';
export const viewModeClassName = 'view-mode';
export const creationLoadingClassName = 'creation-loading';
export const draggingClassName = 'user-is-dragging';
export const SyncBlockStateCssClassName: {
    disabledClassName: string;
    viewModeClassName: string;
    creationLoadingClassName: string;
    draggingClassName: string;
} = {
	disabledClassName,
	viewModeClassName,
	creationLoadingClassName,
	draggingClassName,
};
